import React from 'react';
import { useLocation } from 'react-router-dom';

import Page from '../../components/Page';

import { getSidebarActions } from '../../sections/employee/accounts/SidebarActions';
import TableView from '../../sections/employee/generics/TableView';
import { getDataGridProps } from '../../sections/employee/accounts/DatagridProps';
import Filter from '../../sections/employee/accounts/Filter';
import RowActions from '../../sections/employee/accounts/RowActions';
import AccountsProvider, { useAccounts } from '../../sections/employee/accounts/Context';

export const EmployeesAccounts = () => (
  <Page title="Konta kadry">
    <AccountsProvider>
      <TableView
        sidebarActions={getSidebarActions()}
        dataGridProps={getDataGridProps()}
        FilterComponent={Filter}
        RowActionsComponent={RowActions}
        useCtx={useAccounts}
        showStatePanel={false}
      />
    </AccountsProvider>
  </Page>
);

export default EmployeesAccounts;
